import { render, staticRenderFns } from "./PendingRegistrationDetails.vue?vue&type=template&id=7d07518a&scoped=true"
import script from "./PendingRegistrationDetails.vue?vue&type=script&lang=js"
export * from "./PendingRegistrationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d07518a",
  null
  
)

export default component.exports